import React from "react";

export default function ContractorTickets() {
  return <div>Tickets</div>;
}
